import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { loginCredential, searchCredential, selectedpassengerCredential, redirectToPageCredentials, moduleAndLoginDivDisabled } from '../ReduxState';
import { monthNames, fncGetPaymentNameFromCode, fncAssignSearchedCheckboxes, shortcutKeyForPage, shortcutKeys, isInternationalFlight, checkinModule, checkPassengerStatus, haveTravelDocs, fncCheckIfTokenIsExpired, fncCheckSearchedFlightDetailsEmpty, fncFocusElementDependsOnPathLocation, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu } from '../Utility/CommonFun.js';
import { fncAddPaymentApi, fncRemovePayment, fncGetBookingFromState, fncGetConvinienceFee } from '../Utility/ApiCall.js'
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import MultiSelect from "react-multi-select-component";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css 
import FocusLock from "react-focus-lock";
import { Button, Modal } from 'react-bootstrap';


function Payment({ handleSideMenu }) {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
        const [showDeletePopUp, setshowDeletePopUp] = useState(false);
    
    const [payKey, setPayKey] = useState(null);
  const tabContentRef = useRef(null);
  const yesbutton = useRef(null);
  const tableRef = useRef([]);
  const [activeleftChildIndex, setActiveleftChildIndex] = useState(0); // Track the active left child  index
  const [selectedRow, setSelectedRow] = useState(0);
  const modalRef = useRef(null); // Ref for the modal container
  const notify = (e) =>
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const notifySuccess = (e) =>
        toast.success(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    // debugger;

    let history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const [triggerModal, settriggerModal] = useState(false);
    const ReduxPaymentTypeDropdown = useSelector(state => state.selectedpassenger.PaymentTypeDropdown);
    const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled)
    const [PaymentDropdown, setPaymentDropdown] = useState(ReduxPaymentTypeDropdown);
    const [AddedPayment, setAddedPayment] = useState(SearchedFlightDetails.payment);
    const [AddedPaymentOptions, setPaymentOptions] = useState([]);
    const [AddAmount, setAmount] = useState("");
    const [st_ConvenienceAmount, SetConvenienceAmount] = useState("0.00");
    const [IsAddButtonEnabled, setIsAddButtonEnabled] = useState(true);
    const [st_ErrorAmount, setErrorAmount] = useState("");
    const [st_SwitchToDelete, setSwitchToDelete] = useState(false);
    const [disableFocusOfPaymentcomponent, setdisableFocusOfPaymentcomponent] = useState(false);
    const selectedModule = useSelector(state => state.login.Module);
    const docVerified = useSelector(state => state.docVerify.documentsVerified);
    // debugger;
    // console.log('payment component=====', isInternationalFlight(SearchedFlightDetails), selectedModule, docVerified);
    function fncNextButtonFocus() {
        document.getElementById("btnNextButtonPayment").focus();
    }

    let allCheckedIn = false;

    if (!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule) {
      const passengersForPnr = { ...SearchedFlightDetails };
      const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
      let selectedPassengers = passengerArr;
      allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
    }

    useEffect(() => {
        if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
            history.push('/Search');
        }
    });

    useEffect(() => {
           
        fncNextButtonFocus();
        var amount = SearchedFlightDetails.breakdown.balanceDue;
        setAmount(amount);
    }, [])

    // upadte
      useEffect(() => {
                                     
                    document.addEventListener("onKeyDown", function (event) {
                            
                            if (event.key === 'Enter') {
    
                                            if (document.getElementById("btnNextButtonPayment")) {
                                                    document.getElementById("btnNextButtonPayment").click();
                                            } 
                            }
                    });
                  
            }, []); 

    /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
    useEffect(() => {
        document.addEventListener("keydown", function (event) {  
          if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
            handleSideMenu();
          }
        })
    });

    useEffect(() => {
              document.addEventListener("keydown", shortcutKeyHandler);
              return () => {
                  document.removeEventListener('keydown', shortcutKeyHandler);
              };
          });
      
          const shortcutKeyHandler = (event) => {
              const tag = event.target.tagName.toLowerCase();
              const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
              if(shortcutKeysForPageNavigation.includes(event.key)){
                  const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                  if (path) {
                      history.push('/' + path);
                  }
              }
              if (isTypingField && !event.ctrlKey) return;
              if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
                  if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                          dispatch(redirectToPageCredentials(
                                      {
                                        type: "",
                                        redirectionPage: location.pathname
                                      }
                           ));
                  }
                  const path = shortcutKeyForPage(location.pathname, event);
                  if (path) {
                      history.push('/' + path);
                  }
              }                          
          }

    function fncPaymentTypeChange(e) {
           
        fncNextButtonFocus();
        console.log(e);
        setPaymentOptions([])
        var SelectedService = e.target.options[e.target.selectedIndex].id;
        var filteredPayment = PaymentDropdown.filter(record => record.paymentMethodCode.toUpperCase() === SelectedService.split("-")[0].toUpperCase())

        if (filteredPayment.length != 0) {
            var arrPaymentMethodsFields = filteredPayment[0].paymentMethodFields;
            var arrPaymentOptions = [];
            for (var i = 0; i < arrPaymentMethodsFields.length; i++) {
                if (arrPaymentMethodsFields[i].name.toUpperCase() != "Amount".toUpperCase() && arrPaymentMethodsFields[i].requiredType != 2) {
                    arrPaymentOptions.push({
                        "labelName": arrPaymentMethodsFields[i].name,
                        "id": arrPaymentMethodsFields[i].paymentMethodFieldCode,
                        "PaymentMethodCode": arrPaymentMethodsFields[i].paymentMethodCode,
                        "value": "",
                        "requiredType": arrPaymentMethodsFields[i].requiredType,
                        "valueMaxLength": arrPaymentMethodsFields[i].valueMaxLength,
                        "valueMinLength": arrPaymentMethodsFields[i].valueMinLength,
                        "valueType": arrPaymentMethodsFields[i].valueType,
                        "errorMessage": ""
                    })
                }
            }
            setIsAddButtonEnabled(false);
            setPaymentOptions(arrPaymentOptions);
            SetConvenienceAmount("0.00");
            // implemented on 09 july 2021
            if (filteredPayment.feeCode != null) {
                var data = [
                    {
                        "FeeCode": filteredPayment.feeCode,
                        "Amount": AddAmount,
                        "CurrencyCode": "INR"
                    }
                ];
                document.getElementById("showAndHideSpinner").style.display = "block";
                fncGetConvinienceFee(data)
                    .then((returnVal) => {
                           
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                        }
                        else {
                            if (returnVal.data.isError == false) {
                                   
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                var ConFee = returnVal.data.paymentFeeResponses[0].feeAmount;
                                var TotalAmountPayable = parseInt(ConFee) + AddAmount
                                setAmount(TotalAmountPayable);
                                SetConvenienceAmount(parseInt(ConFee));
                            }
                            else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                        notify(returnVal.data.errorDetail.errorMessage);
                                } 
                            }
                        }
                    })
                    .catch(err => console.log("Axios err: ", err))
            }

        }
    }

    function fncCheckValidation() {
        fncNextButtonFocus();
        if (AddAmount == "" || parseFloat(AddAmount) <= 0 || isNaN(parseInt(AddAmount))) {
            setErrorAmount("*Please enter Amount.")
            return false;
        }
        if (AddedPaymentOptions.length == 0) {
            return false;
        }
        else {
            var sAddedPaymentOptions = [...AddedPaymentOptions];
            var sPaymentMethodCode = sAddedPaymentOptions[0].PaymentMethodCode;
            var filteredPayment = PaymentDropdown.filter(record => record.paymentMethodCode.toUpperCase() === sPaymentMethodCode.toUpperCase());
            var arrPaymentMethodsFields = filteredPayment[0].paymentMethodFields;
            for (var i = 0; i < arrPaymentMethodsFields.length; i++) {
                for (var j = 0; j < sAddedPaymentOptions.length; j++) {
                    if (arrPaymentMethodsFields[i].paymentMethodFieldCode.toUpperCase() == sAddedPaymentOptions[j].id.toUpperCase()) {
                        if (sAddedPaymentOptions[j].value == "" && sAddedPaymentOptions[j].requiredType == 0) {
                            sAddedPaymentOptions[j].errorMessage = "*Please enter " + sAddedPaymentOptions[j].labelName + ".";
                            setPaymentOptions(sAddedPaymentOptions);
                            return false;
                        }
                        //    if(sAddedPaymentOptions[j].valueMinLength>=sAddedPaymentOptions[j].value.length)
                        if (sAddedPaymentOptions[j].valueMinLength > sAddedPaymentOptions[j].value.length) {
                            sAddedPaymentOptions[j].errorMessage = "*Please complete the " + sAddedPaymentOptions[j].labelName + ".";
                            setPaymentOptions(sAddedPaymentOptions);
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }

    function fncAddPayment() {
        fncNextButtonFocus();
        var isValid = fncCheckValidation();
        if (isValid == true) {


            const Token = localStorage.getItem("LoginToken");
            var sAddedPaymentOptions = [...AddedPaymentOptions];
            var sPaymentMethodCode = sAddedPaymentOptions[0].PaymentMethodCode;
            var filteredPayment = PaymentDropdown.filter(record => record.paymentMethodCode.toUpperCase() === sPaymentMethodCode.toUpperCase());
            var arrPaymentMethodsFields = filteredPayment[0].paymentMethodFields;
            var paymentFieldsData = '';
            for (var i = 0; i < arrPaymentMethodsFields.length; i++) {
                for (var j = 0; j < sAddedPaymentOptions.length; j++) {
                    if (arrPaymentMethodsFields[i].paymentMethodFieldCode.toUpperCase() == sAddedPaymentOptions[j].id.toUpperCase()) {
                        var sid = sAddedPaymentOptions[j].id.includes("::");
                        var rId = ""
                        if (sid == true) {
                            rId = sAddedPaymentOptions[j].id.split('::')[1];
                        }
                        else {
                            rId = sAddedPaymentOptions[j].id;
                        }
                        paymentFieldsData = paymentFieldsData + '"' + rId + '":"' + sAddedPaymentOptions[j].value + '",';
                    }
                }
            }

            var PaymentFieldJson = JSON.parse('{' + paymentFieldsData.substring(0, paymentFieldsData.length - 1) + '}')

            var addPayment = [{
                "signature": Token,
                "PaymentMethodRequest":
                {
                    "paymentMethodCode": sPaymentMethodCode,
                    "amount":  parseInt(AddAmount), //AddAmount,
                    "currencyCode": SearchedFlightDetails.currencyCode,
                    "installments": 1,
                    "paymentFields": PaymentFieldJson
                }
            }
            ]
            fncAddPaymentApi(addPayment)
                .then((returnVal) => {
                    // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        // notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {
                            fncSearchApiCallForSeat("Payment added Successfully.");
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            } 
                        }
                    }

                })
                .catch(err => console.log("Axios err: ", err))

        }
        else {
            return false;
        }
    }


    function fncSearchApiCallForSeat(MES) {
        fncNextButtonFocus();

        fncGetBookingFromState()
            .then((returnVal) => {
                   
                // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {

                        if (returnVal.data.flightDetails != null) {

                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");
                               


                        }

                        dispatch(searchCredential(
                            {
                                type: "",
                                SearchedRecordData: stSearchedRecordData,
                                SearchedFlightDetails: assignStateAgain
                            }
                        ));
                        // debugger;
                        setAddedPayment(assignStateAgain.payment);
                        setAmount("");
                        SetConvenienceAmount("0.00");
                        setPaymentOptions([]);
                        notifySuccess(MES);
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                        } 
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                }

            })
            .catch(err => console.log("Axios err: ", err))
    }



    function fncOnChange(e) {
           
        var id = e.target.id.toUpperCase();
        var value = e.target.value;
        if (id == "amount".toUpperCase()) {
            setAmount(value);
            setErrorAmount("");
        }
        else {
            var sAddedPaymentOptions = [...AddedPaymentOptions];
            for (var i = 0; i < sAddedPaymentOptions.length; i++) {
                if (sAddedPaymentOptions[i].id.toUpperCase() == id.toUpperCase()) {
                    //1 =='String', 
                    if (parseInt(sAddedPaymentOptions[i].valueType) == 1) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength) || value == "") {
                            sAddedPaymentOptions[i].value = value;
                            sAddedPaymentOptions[i].errorMessage = "";
                        }
                    }
                    // 2== 'UpperCaseString', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 2) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength) || value == "") {
                            sAddedPaymentOptions[i].value = value.toUpperCase();
                            sAddedPaymentOptions[i].errorMessage = "";
                        }
                    }
                    // 3=='Numeric'
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 3) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                            &&
                            /^[0-9]+$/.test(value)
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 4=='Alphanumeric', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 4) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                            &&
                            value.match(/^[0-9a-zA-Z]+$/)
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 5=='Amount', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 5) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 6=='Date', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 6) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 7==''Mod10'', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 7) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 8=='Name','Address', 'State', 'Zip','Country', 'City', 
                    else if (
                        parseInt(sAddedPaymentOptions[i].valueType) == 8
                        ||
                        parseInt(sAddedPaymentOptions[i].valueType) == 9
                        ||
                        parseInt(sAddedPaymentOptions[i].valueType) == 10
                        ||
                        parseInt(sAddedPaymentOptions[i].valueType) == 11
                        ||
                        parseInt(sAddedPaymentOptions[i].valueType) == 12
                        ||
                        parseInt(sAddedPaymentOptions[i].valueType) == 13
                    ) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                        ) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                    // 14=='Boolean', 
                    else if (parseInt(sAddedPaymentOptions[i].valueType) == 14) {
                        if ((value.length <= sAddedPaymentOptions[i].valueMaxLength
                            &&
                            (value == 0 || value == 1)) || value == "") {
                            sAddedPaymentOptions[i].errorMessage = "";
                            sAddedPaymentOptions[i].value = value;
                        }
                    }
                }
            }
            setPaymentOptions(sAddedPaymentOptions);
        }
    }
    // updated to allowd spaces
    // function fncOnChange(e) {           
    //     var id = e.target.id.toUpperCase();
    //     var value = e.target.value;
        
    //     if (id === "AMOUNT") {
    //         setAmount(value);
    //         setErrorAmount("");
    //     } else {
    //         var sAddedPaymentOptions = [...AddedPaymentOptions];
    
    //         for (var i = 0; i < sAddedPaymentOptions.length; i++) {
    //             if (sAddedPaymentOptions[i].id.toUpperCase() === id.toUpperCase()) {
    //                 let option = sAddedPaymentOptions[i];
    //                 let valueType = parseInt(option.valueType);
    
    //                 if (valueType === 1) {
    //                     if ((value.length <= option.valueMaxLength) || value === "") {
    //                         option.value = value;
    //                         option.errorMessage = "";
    //                     }
    //                 }
    //                 else if (valueType === 2) {
    //                     if ((value.length <= option.valueMaxLength) || value === "") {
    //                         option.value = value.toUpperCase();
    //                         option.errorMessage = "";
    //                     }
    //                 }
    //                 else if (valueType === 3) {
    //                     if ((value.length <= option.valueMaxLength && /^[0-9\s]+$/.test(value)) || value === "") {
    //                         option.errorMessage = "";
    //                         option.value = value;
    //                     }
    //                 }
    //                 else if (valueType === 4) {
    //                     if ((value.length <= option.valueMaxLength && /^[0-9a-zA-Z\s]+$/.test(value)) || value === "") {
    //                         option.errorMessage = "";
    //                         option.value = value;
    //                     }
    //                 }
    //                 else if ([5, 6, 7].includes(valueType)) {
    //                     if (value.length <= option.valueMaxLength || value === "") {
    //                         option.errorMessage = "";
    //                         option.value = value;
    //                     }
    //                 }
    //                 else if ([8, 9, 10, 11, 12, 13].includes(valueType)) {
    //                     if ((value.length <= option.valueMaxLength) || value === "") {
    //                         option.errorMessage = "";
    //                         option.value = value;
    //                     }
    //                 }
    //                 // ✅ 14: Boolean (0 or 1)
    //                 else if (valueType === 14) {
    //                     if ((value.length <= option.valueMaxLength && (value == 0 || value == 1)) || value === "") {
    //                         option.errorMessage = "";
    //                         option.value = value;
    //                     }
    //                 }
    //             }
    //         }
    //         setPaymentOptions(sAddedPaymentOptions);
    //     }
    // }
    

    //   function fncSelectPayment(e)
    function fncSelectPayment(e, id) {
        fncNextButtonFocus();
        //   var payKey= e.target.id;
        var payKey = id;
        var sAddedPayment = [...AddedPayment]
        for (var i = 0; i < sAddedPayment.length; i++) {
            sAddedPayment[i].IsSelected = false;
        }
        for (var i = 0; i < sAddedPayment.length; i++) {
            if (sAddedPayment[i].paymentKey == payKey) {
                sAddedPayment[i].IsSelected = true;
            }
        }
        // debugger;
        setAddedPayment(sAddedPayment);
        setSwitchToDelete(true);
    }


    // function fncDeletePayment(e) {
    //     fncNextButtonFocus();
    //     var payKey = e.target.id;
    //     confirmAlert({
    //         customUI: ({ onClose }) => {
               
    //             return (
    //                 <div className='custom-ui'  id='pop'
    //                           tabIndex={1}          ref={modalRef}>
    //                     <h1>Are you sure?</h1>
    //                     <p>You want to delete this file?</p>
    //                     <button  className='OrangeShadow' onClick={onClose}>No</button>
    //                     <button
    //                 className='OrangeShadow'
    //                         onClick={() => {
    //                             fnchandleClickDelete(payKey);
    //                             onClose();
    //                         }}
    //                     >
    //                         Yes, Delete it!
    //                     </button>
    //                 </div>
    //             );
    //         }
    //     });

    // }

    function fnchandleClickDelete(payKey) {
        fncNextButtonFocus();

        fncRemovePayment(payKey)
            .then((returnVal) => {

                // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {

                        setAmount("");
                        SetConvenienceAmount("0.00");
                        setPaymentOptions([]);
                        setSwitchToDelete(false);
                        fncSearchApiCallForSeat("Payment deleted Successfully.");
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                        }
                    }
                }
                setshowDeletePopUp(false);


            })
            .catch(err => console.log("Axios err: ", err))
    }

    function fncCancel() {
        fncNextButtonFocus();
        setAmount("");
        SetConvenienceAmount("0.00");
        setPaymentOptions([]);
        setSwitchToDelete(false);
    }
    function btnNextButtonPayment() {
        history.push("/finalize");
    }


    // update

    //1/8
    // for next page
    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key === "ArrowRight") {
            btnNextButtonPayment();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, []); 
      // for back page
      useEffect(() => {
        const handleKeyDown = (e) => {
          if (e.ctrlKey && e.key === "ArrowLeft") {
            history.goBack();
          }
        };      
        document.addEventListener("keydown", handleKeyDown);      
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, [history]); 
      
    // Check if Shift + Right , Shift + Left 
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.altKey && event.key.toLowerCase() === 'c') {
                                      if(!IsModulAndLoginDivDisabled){
                                        setdisableFocusOfPaymentcomponent(false);
                                                                 dispatch(moduleAndLoginDivDisabled({
                                                                      type: "MODULE_AND_LOGINDIV_DISABLED",
                                                                      IsModulAndLoginDivDisabled: true
                                                                  }));
                                                                  fncFocusElementDependsOnPathLocation(location.pathname,tabContentRef.current);
                                        }else if (IsModulAndLoginDivDisabled) {
                                            setdisableFocusOfPaymentcomponent(true);
                                                                                    const headingDiv = document.querySelector(".modulebtn");            
                                                                                    if (headingDiv) {                  
                                                                                        headingDiv.focus();
                                                                                        dispatch(moduleAndLoginDivDisabled({
                                                                                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                                                                                IsModulAndLoginDivDisabled: false
                                                                                            }));
                                                                                    }
                                                                                }
                     }
                     else if (event.shiftKey && event.key === "ArrowRight") {
                        event.preventDefault();
                        setActiveleftChildIndex(0);
                        const paymentHistoryTab = document.getElementById("nav-payment-history-tab");
                        if (paymentHistoryTab) {
                            paymentHistoryTab.click();
                            if (tableRef.current[activeleftChildIndex]) {
                                tableRef.current[activeleftChildIndex].focus();
                            }
                        }
            }
            if (event.shiftKey && event.key === "ArrowLeft") {
                event.preventDefault();
                const paymentTab = document.getElementById("nav-payment-tab");
                if (paymentTab) {
                    paymentTab.click();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [activeleftChildIndex,IsModulAndLoginDivDisabled]);

    useEffect(() => {
         if ( tableRef.current[activeleftChildIndex]) {
            tableRef.current[activeleftChildIndex].focus();}
      },[activeleftChildIndex]);


 const handleKeyDown = (e) => {  };
       // for up down
       useEffect(() => {
        const handleKeyDown = (e) => {
          if (!tableRef.current || tableRef.current.length === 0) return;
          if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveleftChildIndex((prevIndex) => {
              const newIndex = Math.max(prevIndex - 1, 0);
              if (tableRef.current[newIndex]) {
                tableRef.current[newIndex].focus();
              }
              return newIndex;
            });
          } 
        //   else if (e.key === "ArrowDown") {
        //     e.preventDefault();
        //     setActiveleftChildIndex((prevIndex) => {
        //       const rows = tableRef.current;
        //       const newIndex = Math.min(prevIndex + 1, rows.length - 1);
        //       if (rows[newIndex]) {
        //         rows[newIndex].focus();
        //       }
        //       return newIndex;
        //     });
        //   }
        else if (e.key === "ArrowDown") {
            e.preventDefault();
        
            setActiveleftChildIndex((prevIndex) => {
              const rows = tableRef.current;
              const lastIndex = rows.length - 1;
                  if (prevIndex >= lastIndex) {
                return prevIndex; 
              }        
              const newIndex = prevIndex + 1;        
              if (rows[newIndex]) {
                rows[newIndex].focus();
              }
        
              return newIndex;
            });
        }
        
        };
      
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, [activeleftChildIndex, AddedPayment]); 
      
     const   handlefocus=() => {
        const amountInput = document.getElementById("Amount");
        if (amountInput) {
          amountInput.focus();
        }
      }

      const fncDeletePayment = (e) => {
        fncNextButtonFocus();  // Keep your existing focus logic.
        setPayKey(e.target.id);
        setshowDeletePopUp(true);
    };


    const handleConfirmDelete = () => {
        fnchandleClickDelete(payKey);  // Your delete logic.
        setshowDeletePopUp(false);
    };

    
        useEffect(() => {
        const handleKeyDown = (e) => {
        if (e.key === "Tab") {
        if (
        document.activeElement.id === "NoDeleteBtn" && 
        !e.shiftKey
        ) {
        e.preventDefault();
        yesbutton.current?.focus(); 
        }    
        }
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => {
        document.removeEventListener("keydown", handleKeyDown);
        };
        });
    
        useEffect(() => {
              if (showDeletePopUp) {
                      yesbutton.current.focus();
              }
        }, [showDeletePopUp]);
    return (
        <FocusLock disabled={disableFocusOfPaymentcomponent}>
        <div class="seat-container white">
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && !allCheckedIn && haveTravelDocs(SearchedFlightDetails)}></DocumentVerificationModal>
           
                      <Modal 
               show={showDeletePopUp}
               onHide={() => setshowDeletePopUp(false)} 
               backdrop="static"
               keyboard={false}
               centered
               dialogClassName="bottom-dialog-modal"
            >
                    <Modal.Header>
                        <Modal.Title id="confirm-delete-title">Are you sure?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>You want to delete this Payment?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary"  ref={yesbutton}  className="confirm-btn OrangeShadow"
                           onClick={handleConfirmDelete}>
                            Yes, Delete it!
                        </Button>
                        <Button id="NoDeleteBtn" className="cancel-btn OrangeShadow"
                         variant="danger" 
                         onClick={() => setshowDeletePopUp(false)}>

                            No
                        </Button>
                    </Modal.Footer>
                
            </Modal>
            <div class="payment-data tab-data">
                <div class="nav nav-tabs" id="nav-tab" role="tablist" tabIndex={-1}>
                    <button class="nav-link active OrangeShadow" id="nav-payment-tab" tabIndex={-1} data-bs-toggle="tab" data-bs-target="#nav-payment" type="button" role="tab" aria-controls="nav-payment" aria-selected="true">{st_SwitchToDelete ? 'Edit Payment' : 'Payment'}</button>
                    <button class="nav-link OrangeShadow" id="nav-payment-history-tab"tabIndex={-1} data-bs-toggle="tab" data-bs-target="#nav-payment-history" type="button" role="tab" aria-controls="nav-payment-history" aria-selected="false">Payment History</button>
                </div>

                <div class="tab-content" id="nav-tabContent" ref={tabContentRef}>
                    {
                        st_SwitchToDelete === false ?
                        // payment
                        <div class="tab-pane fade show active" id="nav-payment" role="tabpanel" aria-labelledby="nav-payment-tab">
                            <div class="row pt-5">
                                <div class="col-sm-4 ">
                                    <div class="form-floating mb-4 ">
                                        <input class="form-control focusClass" type="number" id="Amount" onChange={e => fncOnChange(e)} value={AddAmount} placeholder="amount" />
                                        <label class="bold" for="amount">Amount</label>
                                    </div>
                                    <span className="clsError" >{st_ErrorAmount}</span>
                                </div>
                                <div class="col-sm-4 ">
                                    <div class="form-floating mb-4">
                                        <select class="form-select focusClass" onChange={e => fncPaymentTypeChange(e)} id="paymentType" aria-label="paymentType">
                                            <option>Select the Payment Type</option>
                                            {
                                                PaymentDropdown.length == 0 ? '' :
                                                PaymentDropdown.map((fs) =>
                                                    <option id={fs.paymentMethodCode}>
                                                        {fs.name + " (" + fs.paymentMethodCode + ")"}
                                                    </option>
                                                )
                                            }
                                        </select>
                                        <label class="bold" for="paymentType">Payment Type</label>
                                    </div>
                                </div>
                                <div class="col-sm-4 ">
                                    <div class="form-floating mb-4">
                                        <input class="form-control focusClass" id="convenienceFee" required="" value={st_ConvenienceAmount} />
                                        <label class="bold" for="convenienceFee">Convenience Fee</label>
                                    </div>
                                </div>
                                {
                                    AddedPaymentOptions.length == 0 ? '' :
                                    AddedPaymentOptions.map((fs) => 
                                    <div class="col-sm-4">
                                        <div class="form-floating mb-4">
                                            <input class="form-control not-empty" id={fs.id} type="text"
                                             value={fs.value} 
                                            //  value={value} 
                                             onChange={e => fncOnChange(e)} placeholder="amount" />
                                            <label class="bold" for="amount">{fs.labelName}</label>
                                        </div>
                                        <span className="clsError" >{fs.errorMessage}</span>
                                    </div>
                                    )
                                }
                            </div>

                            <button  id='paybtn'
                              onBlur={handlefocus}
  class="btn btn-primary btn-animation mb-4 SerachBtn" onClick={fncAddPayment} disabled={IsAddButtonEnabled}>
                                <span class="px-5">Pay</span>
                            </button>


                        </div>
                        :
                        // edit payment
                        <div class="tab-pane fade show active" id="nav-payment" role="tabpanel" aria-labelledby="nav-payment-tab">
                            {AddedPayment.length == 0 ? '' :
                                AddedPayment.map((pay, i) =>
                                    pay.IsSelected == true ?
                                    <div class="row pt-5">
                                        <div class="col-sm-4" >
                                            <div class="form-floating mb-4">
                                                <input tabIndex={-1} class="form-control" value={pay.amounts.amount} placeholder="amount" />
                                                <label class="bold" for="amount">Amount</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 ">
                                            <div class="form-floating mb-4">
                                                <input tabIndex={-1} class="form-control" value={fncGetPaymentNameFromCode(ReduxPaymentTypeDropdown, pay.code) + " (" + pay.code + ")"} />
                                                <label class="bold" for="paymentType">Payment Type</label>
                                            </div>
                                        </div>
                                        {
                                            pay.details.fields.length == 0 ? '' :
                                            pay.details.fields.map((fs) => 
                                            <div class="col-sm-4 ">
                                                <div class="form-floating mb-4">
                                                    <input type="text" class="form-control" required="" value={fs.fieldValue} disabled />
                                                    <label class="bold" for="convenienceFee">{fs.fieldName}</label>
                                                </div>
                                                <span className="clsError" >{fs.errorMessage}</span>
                                            </div> 
                                            )
                                        }
                                        <div className="col-sm-4 text-right tab-btn-flex">
                                            {pay.approvalDate != null ? "" :
                                                <button id={pay.paymentKey} onClick={(e) => { fncDeletePayment(e) }} type="button" class="btn btn-red-holo px-4 mx-2 SerachBtn">Delete</button>
                                            }
                                            <button type="button"  onClick={fncCancel} className="btn btn-red px-4 mx-2 btn-animation SerachBtn">Cancel</button>
                                        </div>                          
                                    </div>
                                    : ""
                            )}
                        </div>                      
                    }     
                        {/* history         */}
                    <div class="tab-pane fade" id="nav-payment-history" role="tabpanel" aria-labelledby="nav-payment-history-tab"
                    tabIndex={-1} // Make the div focusable
                    >
                        <div class="paymentHistory-table  mt-4">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="font-sm bold dark-text">Date</th>
                                        <th class="font-sm bold dark-text">Payment Type</th>

                                        <th class="font-sm bold dark-text">Amount</th>
                                        <th class="font-sm bold dark-text">Status</th>
                                    </tr>
                                </thead>
                                {
                                    AddedPayment == null ? '':AddedPayment.length == 0 ? '':
                                    AddedPayment.map((pay, i) =>
                                    <tbody tabIndex={-1}>
                                        <tr  key={pay.paymentKey} className={`font-sm mid-dark-text ${i === selectedRow ? 'selected-row focusClass OrangeShadow' : 'focusClass OrangeShadow'}`} ref={(el) => (tableRef.current[i] = el)} id={pay.paymentKey} 
                                        onClick={(e) => { fncSelectPayment(e, pay.paymentKey) }}
                                         onKeyDown={(e) => { 
                                            if (activeleftChildIndex === i) { 
                                                handleKeyDown(e); 
                                            } 
                                            if (e.key === "Enter") {
                                                e.preventDefault(); 
                                                fncSelectPayment(e, pay.paymentKey);
                                            }
                                        }}
                                        tabIndex={0}
                                        >
                                            <td class="font-sm mid-dark-text">
                                                {pay.approvalDate == null ? new Date(pay.createdDate).getDate() + "" + monthNames[new Date(pay.createdDate).getMonth()] + "" + (new Date(pay.createdDate).getFullYear()): new Date(pay.approvalDate).getDate() + "" + monthNames[new Date(pay.approvalDate).getMonth()] + "" + (new Date(pay.approvalDate).getFullYear())}
                                            </td>
                                            <td class="font-sm mid-dark-text">
                                                {fncGetPaymentNameFromCode(ReduxPaymentTypeDropdown, pay.code)}
                                            </td>
                                            <td class="font-sm mid-dark-text">{SearchedFlightDetails.currencyCode} {pay.amounts.amount}</td>
                                            <td class="font-sm mid-dark-text">{pay.status}</td>
                                        </tr>
                                    </tbody>
                                    )
                                }
                            </table>
                        </div>

                    </div>
                </div>
            </div>
            <div class="btn-container mobile-fix-bottom">
                <a class="btn btn-primary-dark" onClick={() => history.goBack()}>
                    <span class="px-4"><span class="icon me-2"><img class=" rotate180" src="newImages/i-arrow-right.svg" /> <img class=" rotate180" src="newImages/i-arrow-right.svg" /></span>Previous</span>
                </a>
                <a class="btn btn-secondary" id="btnNextButtonPayment" onClick={btnNextButtonPayment}>
                    <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                </a>
            </div>
        </div>
        </FocusLock>
    );
}

export default Payment;